import type { Logger } from '@vp/ubik-logging'

import type { MerchandisingPropertyV2 } from '../types/MsxProperty'
import { REQUESTOR } from '../utils/constants'

const baseUrl = 'https://merchandising-site-experience.prod.merch.vpsvc.com'

export const getAttributesAndValues = async (
  tenant: string,
  productKey: string,
  productVersion: number,
  culture: string,
  logger: Logger,
): Promise<MerchandisingPropertyV2[]> => {
  const queryParams = new URLSearchParams({
    cultures: culture,
    requestor: REQUESTOR,
  })

  const url = `${baseUrl}/api/v2/tenant/${tenant}/productKey/${productKey}/version/${productVersion}/experienceandordering/attributesandvalues?${queryParams.toString()}`
  try {
    const request = new Request(url)

    const response = await fetch(request)

    if (!response.ok) {
      throw new Error(`Request to ${url} failed with status: ${response.status}`)
    }

    const res = (await response.json()) as { [locale: string]: { list: MerchandisingPropertyV2[] } }
    if (res[culture.toLowerCase()]?.list) {
      return res[culture.toLowerCase()]?.list ?? []
    } else {
      throw new Error(`MSX cannot find the list attribute data for product key ${productKey} in locale ${culture}`)
    }
  } catch (error) {
    logger.error('Failed to get the list attribute data:', error as Error, { productKey, productVersion, culture, url })
    return []
  }
}
